import firebase from "firebase/app";
import "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDcqf0Jc93n83ThrtbYS8_tWZVPAaKmYvM",
  authDomain: "market-moves.firebaseapp.com",
  databaseURL: "https://market-moves.firebaseio.com",
  projectId: "market-moves",
  storageBucket: "market-moves.appspot.com",
  messagingSenderId: "182225523753",
  appId: "1:182225523753:web:869649f0a9fe8bf3f07838",
  measurementId: "G-21YLVB0HY8"
};

// const firebaseConfig = {
//   apiKey: "AIzaSyAzElil2OaZdyerJuxHBZJxdEWJ-gT306U",
//   authDomain: "discord-8978a.firebaseapp.com",
//   databaseURL: "https://discord-8978a.firebaseio.com",
//   projectId: "discord-8978a",
//   storageBucket: "discord-8978a.appspot.com",
//   messagingSenderId: "648358878510",
//   appId: "1:648358878510:web:cd69415eac3b18c05f2ebf",
//   measurementId: "G-E2MZKEYH1K"
// };

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
const db = app.firestore();

export default db;
